<template>
  <!-- Add Terminal Button -->
  <v-row class="pa-3 mt-1 pr-0 d-flex justify-end">
    <v-col class="text-end">
      <v-btn color="primary" prepend-icon="mdi-star-plus-outline" @click="openAddFavDialog()">
        {{ $t("common.action.addFavorite") }}
      </v-btn>
    </v-col>
  </v-row>

  <v-card class="mb-0 pb-0">
    <v-layout full-height>
      <v-app-bar flat class="ml-3 text-grey-darken-3">
        <v-icon class="mdi-36px ml-3" color="yellow">mdi-star</v-icon>
        <v-card-title class="text-body-1 font-weight-medium">{{
          $t("page.dashboard.favoriteTerminals")
        }}</v-card-title>
      </v-app-bar>
      <v-main>
        <v-divider />
        <v-card class="pt-0">
          <v-row class="pa-2 d-flex justify-center flex-column" no-gutters>
            <v-col v-for="terminal in activeFavoriteTerminals" :key="terminal.id">
              <v-hover>
                <template v-slot:default="{ isHovering, props }">
                  <v-card
                    v-bind="props"
                    :class="
                      isHovering && terminal?.active
                        ? 'mx-4 my-2 text-white'
                        : 'mx-4 my-2 text-grey-darken-2'
                    "
                    :color="
                      isHovering && terminal?.active
                        ? 'light-blue-darken-1'
                        : 'light-blue-lighten-5'
                    "
                    @click="
                      terminal?.active
                        ? createPayment(terminal?.terminalId, terminal?.locationId)
                        : null
                    "
                  >
                    <v-row class="d-flex justify-between">
                      <v-col cols="6">
                        <v-card-text class="py-0 text-black">{{ terminal.label }}</v-card-text>
                        <v-card-subtitle class="text-caption">{{
                          terminal.location
                        }}</v-card-subtitle>
                      </v-col>

                      <v-col cols="6" class="d-flex align-center">
                        <status-chip
                          :status="
                            terminal?.active ? TerminalStatus.ACTIVE : TerminalStatus.INACTIVE
                          "
                        />
                        <v-row class="d-flex justify-end">
                          <v-menu>
                            <template v-slot:activator="{ props }">
                              <v-btn
                                variant="plain"
                                append-icon="mdi-dots-vertical"
                                v-bind="props"
                              />
                            </template>
                            <v-list density="comfortable">
                              <v-list-item @click="dialogVisible = true">
                                <v-list-item-title class="text-body-2">{{
                                  $t("common.action.remove")
                                }}</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-row>
                        <remove-terminal-dialog
                          v-model="dialogVisible"
                          @close="dialogVisible = false"
                          :terminal="terminal.id"
                          @action="dialogVisible = false"
                          @deleted="handleFavReadersUpdated()"
                        />
                      </v-col>
                    </v-row>
                  </v-card>
                </template>
              </v-hover>
            </v-col>
          </v-row>
        </v-card>
      </v-main>
    </v-layout>
  </v-card>
  <add-favorite-terminal-dialog ref="addFavTerminalDialog" @added="handleFavReadersUpdated()" />
</template>

<script lang="ts" setup>
import StatusChip from "@/shared/components/Common/StatusChip.vue";
import RemoveTerminalDialog from "./RemoveTerminalDialog.vue";
import { computed, ref } from "vue";
import AddFavoriteTerminalDialog from "@/dashboard/components/dashboard/AddFavoriteTerminalDialog.vue";
import { useRouter } from "vue-router";
import { Emit } from "@/shared/enums/emit.enum";
import { TerminalStatus } from "@/shared/enums/status.enum";
import type { FavoriteTerminal } from "@/dashboard/types/dashboard";
const router = useRouter();
const dialogVisible = ref(false);
const addFavTerminalDialog = ref<null | { open: () => null }>(null);
const emit = defineEmits([Emit.UPDATED]);

const props = defineProps<{
  favoriteTerminals: FavoriteTerminal[];
}>();

const activeFavoriteTerminals = computed(() => {
  return props.favoriteTerminals.filter((terminal) => terminal.active === true);
});

const handleFavReadersUpdated = () => {
  emit(Emit.UPDATED);
};

const createPayment = (terminalId: string, locationId: string) => {
  router.push({ name: "createPayment", query: { terminalId, locationId } });
};

const openAddFavDialog = () => {
  addFavTerminalDialog.value?.open();
};
</script>
